var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            "label-width": "120px",
            rules: _vm.rules
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "失物招领标题", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          disabled: _vm.isDetail,
                          placeholder: "请输入失物招领标题",
                          maxlength: "20"
                        },
                        model: {
                          value: _vm.childData.title,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "title", $$v)
                          },
                          expression: "childData.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "拾取人姓名", prop: "pickUpUserName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          disabled: _vm.isDetail,
                          placeholder: "请输入拾取人姓名",
                          maxlength: "10"
                        },
                        model: {
                          value: _vm.childData.pickUpUserName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "pickUpUserName", $$v)
                          },
                          expression: "childData.pickUpUserName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "拾取人联系方式",
                        prop: "pickUpUserPhone"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          disabled: _vm.isDetail,
                          placeholder: "请输入拾取人联系方式",
                          maxlength: "11"
                        },
                        model: {
                          value: _vm.childData.pickUpUserPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "pickUpUserPhone", $$v)
                          },
                          expression: "childData.pickUpUserPhone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "拾取地点", prop: "pickUpPlace" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          disabled: _vm.isDetail,
                          placeholder: "请输入拾取地点",
                          maxlength: "20"
                        },
                        model: {
                          value: _vm.childData.pickUpPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "pickUpPlace", $$v)
                          },
                          expression: "childData.pickUpPlace"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "拾取时间" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "260px" },
                        attrs: {
                          disabled: _vm.isDetail,
                          type: "datetime",
                          placeholder: "请选择拾取时间",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.childData.pickUpDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "pickUpDate", $$v)
                          },
                          expression: "childData.pickUpDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领取地点" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          disabled: _vm.isDetail,
                          maxlength: "20",
                          placeholder: "请输入领取地点"
                        },
                        model: {
                          value: _vm.childData.receivePlace,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receivePlace", $$v)
                          },
                          expression: "childData.receivePlace"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "详情" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "640px" },
                        attrs: {
                          clearable: "",
                          disabled: _vm.isDetail,
                          maxlength: "200",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 2 }
                        },
                        model: {
                          value: _vm.childData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "remark", $$v)
                          },
                          expression: "childData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "required", attrs: { label: "图片" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            name: "files",
                            limit: 1,
                            "on-error": _vm.handleError,
                            "on-success": _vm.handleSuccess,
                            action: _vm.uploadUrl,
                            "on-preview": _vm.handlePreview,
                            "on-remove": _vm.handleRemove,
                            "on-exceed": _vm.handleExceed,
                            "file-list": _vm.files,
                            "before-upload": _vm.beforeUpload,
                            disabled: _vm.isDetail
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "primary",
                                disabled: _vm.isDetail
                              }
                            },
                            [_vm._v("点击上传")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: { visible: _vm.dialogVisible, title: "预览" },
                          on: {
                            "update:visible": function($event) {
                              _vm.dialogVisible = $event
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.dialogImageUrl,
                              alt: ""
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: { label: "拾取物品列表" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.isDetail,
                            icon: "el-icon-circle-plus-outline"
                          },
                          on: { click: _vm.handleAdd }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.add")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "55" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "物品名称",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.goodsName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "物品类型",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.goodsTypeValue))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "物品特点",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.goodsSpecial))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width",
              "min-width": "100px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    !_vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-edit"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleUpdate(scope.row, scope.$index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.edit")))]
                        )
                      : _vm._e(),
                    _vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-search"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleCheck(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                    !_vm.isDetail
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.$index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.delete")))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "margin-top": "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          !_vm.isDetail
            ? _c("el-button", { on: { click: _vm.handCancle } }, [
                _vm._v(_vm._s(_vm.$t("button.cancel")))
              ])
            : _vm._e(),
          !_vm.isDetail
            ? _c(
                "el-button",
                {
                  attrs: { loading: _vm.isSend, type: "primary" },
                  on: { click: _vm.handleConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("button.save")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.previewTitle,
            visible: _vm.dialogFormVisible,
            width: "650px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("goods-add", {
            attrs: {
              "goods-info": _vm.goodsObj,
              "is-check": _vm.isCheck,
              "show-dialog": _vm.dialogFormVisible,
              "is-update-goods": _vm.isUpdateGoods
            },
            on: {
              handCancle: _vm.handCanclePre,
              transferGoodsObj: _vm.receiveGoodsObj
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }